import Vue from 'vue'
import Buefy from 'buefy'
import VeeValidate from 'vee-validate'
import VueGtag from 'vue-gtag'
import { VueReCaptcha } from 'vue-recaptcha-v3'
import validationMessagesEn from 'vee-validate/dist/locale/en'
import validationMessagesTr from 'vee-validate/dist/locale/tr'
import App from './App.vue'
import router from './router'
import store from './store'

import ApiService from './_api/api.service'
import { setPageLocation, trackPage } from './_helpers/analytics'
import { initSentry } from './_helpers/sentry'
import { checkSessionOnLoad } from './_helpers/session'
import DateFilter from './_helpers/date.filter'

import './assets/scss/app.scss'
// import './assets/scss/custom-theme.scss'
import i18n from './i18n'

import GlobalComponents from './plugins/globalComponents'
import GlobalDirectives from './plugins/globalDirectives'

initSentry(Vue)

Vue.use(Buefy, { defaultIconPack: 'fas' })

Vue.use(VeeValidate, {
  i18n,
  dictionary: {
    en: validationMessagesEn,
    tr: validationMessagesTr
  },
  events: '',
  fieldsBagName: 'vFields',
  mode: 'lazy'
})

Vue.use(VueReCaptcha, {
  siteKey: '6LfnT9MtAAAAAFV9Rh918A8RwiWwmnETK6JUBUcF',
  loaderOptions: {
    useRecaptchaNet: true
  }
})

Vue.use(
  VueGtag,
  {
    config: { id: 'G-D8GHT4KSCQ' },
    includes: [{ id: 'AW-782513152' }],
    pageTrackerTemplate: trackPage
  },
  router
)
// queued before vue-gtag's config commands, which wait for the router
setPageLocation()

Vue.use(GlobalComponents)
Vue.use(GlobalDirectives)

Vue.filter('date', DateFilter.date)
Vue.filter('datetime', DateFilter.datetime)

ApiService.init()

Vue.config.productionTip = false

new Vue({
  router,
  store,
  i18n,
  render: h => h(App)
}).$mount('#app')

checkSessionOnLoad(router)
